import { executeRequest } from "./hooks/useApiQuery";

type ApiEnvelope<T> = {
  success: boolean;
  message?: string;
  data: T;
};

export interface NextPresignedUrlRequest {
  recordingId: string;
  kind: string;
  fileType?: string;
}

export interface NextPresignedUrlResponse {
  url: string;
  index: number;
  key?: string;
}

export interface SaveChunkRequest {
  recordingId: string;
  kind: string;
  index: number;
  url: string;
  size?: number;
  durationMs?: number;
  etag?: string;
}

export interface MarkRecordingCompleteRequest {
  recordingId: string;
  kind: string;
}

export const getNextPresignedUrl = async (
  body: NextPresignedUrlRequest
): Promise<NextPresignedUrlResponse> => {
  const response = await executeRequest<ApiEnvelope<NextPresignedUrlResponse>>({
    url: "/s3-recordings/next-presigned-url",
    method: "POST",
    body: { ...body },
  });

  return response.data;
};

export const saveChunkMeta = async (
  request: SaveChunkRequest
): Promise<unknown> => {
  const { recordingId, ...body } = request;
  const response = await executeRequest<ApiEnvelope<unknown>>({
    url: `/s3-recordings/${encodeURIComponent(recordingId)}/chunks`,
    method: "POST",
    body: { ...body },
  });

  return response.data ?? response;
};

export const markRecordingComplete = async (
  request: MarkRecordingCompleteRequest
): Promise<unknown> => {
  const { recordingId, kind } = request;
  const response = await executeRequest<ApiEnvelope<unknown>>({
    url: `/s3-recordings/${encodeURIComponent(recordingId)}/complete`,
    method: "POST",
    body: { kind },
  });

  return response.data ?? response;
};
